import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Avatar from '../images/avatar.png';

const containerVariants = {
	hidden: { opacity: 1 },
	visible: {
		opacity: 1,
		transition: {
			delayChildren: 0.4 * 1,
			staggerChildren: 0.12,
			when: 'beforeChildren',
		},
	},
};

const letterVariants = {
	hidden: { opacity: 0 },
	visible: {
		opacity: 1,
	},
};

function About() {
	const [isInView, setIsInView] = useState(false);
	const name = 'Judith Onyekwelu';
	const profession = 'Frontend Developer';

	return (
		<div id="about" className="max-w-screen-2xl h-fit m-auto my-44 scroll-mt-36">
			<motion.div
				whileInView={() => {
					setIsInView(true);
					return {};
				}}
				className="w-11/12 mx-auto mt-20 flex flex-col md:flex-row-reverse justify-center md:justify-between items-center gap-7 md:gap-0"
			>
				<motion.div
					initial={{ opacity: 0, scale: 0 }}
					whileInView={{
						opacity: 1,
						scale: 1,
						transition: { delay: 0.3, duration: 0.8 },
					}}
					viewport={{ once: true }}
					className="w-full md:w-3/6 flex flex-col justify-center items-center"
				>
					<div className="w-full flex flex-col justify-center items-center relative">
						<motion.div className="w-[245px] xs:w-[300px] h-[145px] xs:h-[200px] rounded-[50%] border-[7px] xs:border-[10px] border-solid border-naive border-l-transparent border-b-transparent absolute rotate-[-45deg] z-0"></motion.div>
						<motion.div className="w-[255px] xs:w-[320px] h-[155px] xs:h-[220px] rounded-[50%] border-[12px] xs:border-[20px] border-solid border-blue border-t-transparent border-r-transparent absolute rotate-[-45deg] shadow-[0px_0px_75px_rgba(0,0,0,1)] z-20"></motion.div>
						<img
							src={Avatar}
							alt="my avatar"
							className="h-[180px] xs:h-[250px] relative top-[-22.5px] xs:top-[-32px] z-30 rounded-br-[100px] rounded-tr-[100px] rounded-bl-[95px] rounded-tl-[95px] xs:rounded-bl-[75px] xs:rounded-tl-[75px]"
						/>
					</div>
					<div className="w-full mt-8 flex flex-col justify-center items-center">
						<motion.h1
							variants={containerVariants}
							initial="hidden"
							whileInView="visible"
							className="w-fit h-fit mx-auto text-center"
						>
							<p className="mb-3 text-2xl xs:text-3xl font-bold relative before:w-14 before:h-[3px] before:bg-smoke-white before:absolute before:left-[40%] before:bottom-[-7.5px] ">
								{name.split('').map((char, index) => (
									<motion.span
										key={char + '-' + index}
										variants={letterVariants}
									>
										{char}
									</motion.span>
								))}
							</p>
							<p className="mt-3 font-normal text-xl xs:text-2xl text-center tracking-[5px]">
								{profession.split('').map((char, index) => (
									<motion.span
										key={char + '-' + index}
										variants={letterVariants}
									>
										{char}
									</motion.span>
								))}
							</p>
						</motion.h1>
					</div>
				</motion.div>
				<motion.div
					initial={{ opacity: 0, x: '-100vw' }}
					animate={
						isInView && {
							opacity: 1,
							x: 0,
							transition: { delay: 0.3, duration: 0.8 },
						}
					}
					className="w-full md:w-3/6 text-justify md:text-left text-base"
				>
					<p className="mb-5">
						I am a self-taught Frontend Developer with 3+ years of professional experience, 
						building responsive, accessible, and high-performance web applications. I have worked across both Web2 and Web3, 
						delivering scalable solutions with a strong focus on user experience, performance, and maintainable frontend architecture.
					</p>
					<p className="mb-5">
						As the sole frontend developer on a hackathon-winning project, 
						I built a responsive and intuitive interface that played a key role in the team's success.
					</p>
					<p>
						I am passionate about continuous learning and building impactful digital products that solve real-world problems.
					</p>
				</motion.div>
			</motion.div>
		</div>
	);
}





export default About;
